<script>
  import componentEditorMixin from '@/components/ProductComponents/CreateComponents/componentEditorMixin.js'
  export default {
    name: "dynamicLabelEditor",
    mixins: [componentEditorMixin],
    data() {
      return {
        timeOutId:'',//定时器
        formList: [
          'textForm',
          'labelForm'
        ],
        ruleList: [
          //textForm
          {

          },
          //labelForm
          {
            textSize: [
              {
                required: true,
                message: '请输入字体大小'
              },
              {
                type : 'number',
                message : '字体大小输入数字'
              }
            ],
            textStyle:[
              {
                required: true,
                message: '请选择字体样式'
              }
            ],
            borderWidth: [
              {
                required: true,
                message: '请输入边框宽度'
              },
              {
                type : 'number',
                message : '边框宽度输入数字'
              }
            ]
          }
        ],
        //字体样式
        txtStyleList: [
              {
              value: 'Times New Roman',
              name: 'Times New Roman'
              },
              {
                value: 'Arial',
                name: 'Arial'
              },
              {
                value: 'Georgia',
                name: 'Georgia'
              },
              {
                value: '宋体',
                name: '宋体'
              },
              {
                value: '黑体',
                name: '黑体'
              }
        ],
        bindTypeList: [
          {
            name: '文本',
            value: 'text'
          },
          {
            name: '数值',
            value: 'number'
          },
        ]
      }
    },
    computed: {
        specificForms() {
          return (
            <div class="specificForms">
              <el-collapse-item class="specificForm" title="标签效果选项" name="2">
                <template slot="default">
                  <div class="specificForm">
                    <el-form id="labelForm" {...{attrs: {model: this.newSettings}}} ref="labelForm" label-style={this.formLabelStyle}>
                      <el-form-item label="缺省文本" prop="text" label-position={this.labelPosition} >
                        <editor-field {...{
                          attrs: {
                            value: this.newSettings.text,  // 需要展示 对象 or 字符串 供组件判断展示 "绑定变量：xxx"
                            type: 'input',
                            varList: this.varList,
                            varJson: this.varJson,
                            showEditButton: !this.newSettings.time,
                            label: "缺省文本",
                            able:this.newSettings.time
                          }
                        }}{...{
                          on: {
                            'input': val => {
                              this.newSettings.text = val
                              this.handleConfirmBtnClick()
                            },
                          }
                        }}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="时间标签" prop="text" label-position={this.labelPosition}>

                        <editor-field {...{
                          attrs: {
                            value: this.newSettings.time,  // 需要展示 对象 or 字符串 供组件判断展示 "绑定变量：xxx"
                            type: 'switch',
                            varList: this.varList,
                            varJson: this.varJson,
                            showEditButton: true,
                            label: "时间标签",
                          }
                        }}{...{
                          on: {
                            'input': val => {
                              this.showTimeChange(val)
                              this.handleConfirmBtnClick()
                            },
                          }
                        }}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="可否编辑" prop="editable" label-position={this.labelPosition}>
                        <editor-field {...{
                          attrs: {
                            value: this.newSettings.editable,
                            type: 'switch',
                            varList: this.varList,
                            varJson: this.varJson,
                            showEditButton: true,
                            label: "可否编辑",
                          }
                        }}{...{
                          on: {
                            'input': val => {
                              this.newSettings.editable = val
                              this.handleConfirmBtnClick()
                            },
                          }
                        }}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="字体颜色" prop="textColor" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.textColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"字体颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.textColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="字号" prop="textSize" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.textSize,
                          type: 'input',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"字号",
                          }}}{...{on: {
                            'input': val=>{
                              this.textSizeChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="字体" prop="textStyle" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.textStyle,
                          type: 'select',
                          selectList: this.txtStyleList,
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"字体",
                          }}}{...{on: {
                            'input': val=>{
                              this.textStyleChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="标签颜色" prop="labelColor" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.labelColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"标签颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.labelColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="边框颜色" prop="borderColor" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.borderColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"边框颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.borderColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="边框宽度" prop="borderWidth" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.borderWidth,
                          type: 'input',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"边框宽度",
                          }}}{...{on: {
                            'input': val=>{
                              this.borderWidthChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="显示边框" prop="showLabelBorder" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.showLabelBorder,
                          type: 'switch',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"显示边框",
                          }}}{...{on: {
                            'input': val=>{
                              this.showLabelBorderChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="透明背景" prop="transparentBackground" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.transparentBackground,
                          type: 'switch',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"透明背景",
                          }}}{...{on: {
                            'input': val=>{
                              this.transparentBackgroundChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                    </el-form>
                  </div>
                </template>
              </el-collapse-item>

            </div>
          )
        },
  // <el-collapse-item className="specificForm" title="文本选项" name="3">
  //   <template slot="default">
  //     <div className="specificForm">
  //       <el-form id="textForm" props={{model: this.newSettings}} ref="textForm"
  //                label-style={this.formLabelStyle}>
  //
  //       </el-form>
  //     </div>
  //   </template>
  // </el-collapse-item>
      },

      methods: {
      //是否展示时间标签
        showTimeChange(val){
          if(val){
            this.handleUniversalChangeSize('162', 'width')
            this.handleUniversalChangeSize('43', 'height')
          }else{
            this.newSettings.text = '标签';
            this.handleUniversalChangeSize('100', 'width')
            this.handleUniversalChangeSize('40', 'height')
          }
          this.newSettings.time = val;
        },
        //这里是获取系统时间，本来在这边改时间，后面换到组件本身去改了
        // getSystemTime(){
        //   const currentDate = new Date();
        //   const year = currentDate.getFullYear();
        //   const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        //   const day = String(currentDate.getDate()).padStart(2, '0');
        //   const hours = String(currentDate.getHours()).padStart(2, '0');
        //   const minutes = String(currentDate.getMinutes()).padStart(2, '0');
        //   const seconds = String(currentDate.getSeconds()).padStart(2, '0');
        //   const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        //   this.newSettings.text = formattedDate;
        // },
        textColorChange(val){
          console.log(val)
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'color' : val
          }
          this.newSettings.textColor = val
        },
        textSizeChange(val){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'font-size' : val + 'px'
          }
          this.newSettings.textSize = val
        },
        textStyleChange(val){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'font-family' : val
          }
          this.newSettings.textStyle = val
        },
        labelColorChange(val){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'background-color' : val
          }
          this.newSettings.labelColor = val
        },
        borderColorChange(val){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'border-color' : val
          }
          this.newSettings.borderColor = val
        },
        borderWidthChange(val){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'border-width' : val + 'px'
          }
          this.newSettings.borderWidth = val
        },
        showLabelBorderChange(val){
          this.newSettings.showLabelBorder = val
          if(val == false){
            this.styleMergeObj = {
              ...this.styleMergeObj,
              'border-color' : 'transparent',
              'border-width' : 0
            }
          }
          if(val == true){
            this.styleMergeObj = {
              ...this.styleMergeObj,
              'border-color' : this.newSettings.borderColor,
              'border-width' : this.newSettings.borderWidth + 'px'
            }
          }
        },
        transparentBackgroundChange(val){
          this.newSettings.transparentBackground = val
          if(val == false){
            this.styleMergeObj = {
              ...this.styleMergeObj,
              'background-color' : this.newSettings.labelColor
            }
          }
          if(val == true){
            this.styleMergeObj = {
              ...this.styleMergeObj,
              'background-color' : 'transparent'
            }
          }
        },
        dynamicLabelState(val,attr){
          this.$set(this.newSettings, attr, val)
        }
      },
      watch:{
        'settings.text'(){
          this.$set(this.newSettings, 'text', this.settings.text)
        }
      }

  }
</script>

<style lang="less">
  .dynamicLabelEditor {
    .singleSelect {
      height: 30px;
      line-height: 30px;
      width: 100%;
      border-radius: 5px;
      padding: 0 10px;
    }
  }
</style>
